import {
  ErrorReportApi,
  GeneralApi,
  ProductsApi,
  ThresholdsApi,
  WallStructuresApi,
} from '~/api/webservice';

import { Configuration } from './api/webservice/configuration';
import apiClient from './apiClient';

const port = import.meta.env.VITE_BACKEND_PORT || 3011;

const basePath =
  import.meta.env.VITE_API_URL ||
  `http://localhost:${port}`;

export const CONFIG = new Configuration({
  basePath,
});

export const wallStructuresAPI = new WallStructuresApi(CONFIG);
export const thresholdsAPI = new ThresholdsApi(CONFIG);
export const productsAPI = new ProductsApi(CONFIG, basePath, apiClient);
export const matomoAPI = new GeneralApi(CONFIG);
export const errorReportAPI = new ErrorReportApi(CONFIG);
